import React from 'react';
import { AppProvider, useApp } from '@/context/AppContext';
import {
  CustomerHome,
  CustomerEarn,
  CustomerRedeem,
  CustomerVouchers,
  CustomerHistory,
} from '@/pages/customer/CustomerPages';
import { AdminLayout } from '@/pages/admin/AdminPages';
import { PartnerLayout } from '@/pages/partner/PartnerPages';
import { ViewSwitcher } from '@/components/layout/Navigation';
import { Toaster } from '@/components/ui/sonner';
import { toast } from 'sonner';
import '@/index.css';

// Customer Layout Component
function CustomerLayout() {
  const { activeTab } = useApp();

  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return <CustomerHome />;
      case 'earn':
        return <CustomerEarn />;
      case 'redeem':
        return <CustomerRedeem />;
      case 'vouchers':
        return <CustomerVouchers />;
      case 'history':
        return <CustomerHistory />;
      default:
        return <CustomerHome />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      {renderContent()}
    </div>
  );
}

// Main App Content
function AppContent() {
  const { currentView, notifications } = useApp();

  // Show toast notifications
  React.useEffect(() => {
    if (notifications.length > 0) {
      const latestNotification = notifications[notifications.length - 1];
      if (latestNotification.type === 'success') {
        toast.success(latestNotification.message);
      } else if (latestNotification.type === 'error') {
        toast.error(latestNotification.message);
      } else {
        toast.info(latestNotification.message);
      }
    }
  }, [notifications]);

  const renderView = () => {
    switch (currentView) {
      case 'customer':
        return <CustomerLayout />;
      case 'admin':
        return <AdminLayout />;
      case 'partner':
        return <PartnerLayout />;
      default:
        return <CustomerLayout />;
    }
  };

  return (
    <>
      <ViewSwitcher />
      {renderView()}
      <Toaster position="top-center" richColors />
    </>
  );
}

// Main App Component
function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

export default App;
